module.exports = __webpack_public_path__ + "37203078546fc1cf923565719fcc177f.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/cert.png
// module id = 1503
// module chunks = 0